import React from 'react';

const WizardStep = ({ title, active }) => {
  return (
    <div className={"col " + (active ? "step-title-active" : "step-title")}>
      <div className="step-text">{title}</div>
    </div>
  );
};
export default WizardStep;